module.exports = __webpack_public_path__ + "static/seo-banner-556a59832864d183f5016aea384d442d.jpg";